<template>
  <b-modal
    v-model="dialog"
    title="Sales Drill-down"
    size="lg"
    @hidden="$emit('update:visible', false)"
  >
    <p class="mb-2"><strong>Level:</strong> {{ drilldownLevel }}</p>
    <b-table :items="drilldownData" :fields="fields" per-page="10" small striped responsive></b-table>
    <template #modal-footer>
      <b-button variant="primary" @click="dialog = false">Close</b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BTable, BButton } from 'bootstrap-vue';
import { dashboardGet } from './dashboardApi';

export default {
  name: 'SalesDrillModal',
  components: {
    BModal,
    BTable,
    BButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    drilldownLevel: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    saleId: {
      type: [String, Number],
      default: null,
    },
    baseApi: {
      type: String,
      default: () => process.env.VUE_APP_APIENDPOINT || '',
    },
    accessToken: {
      type: String,
      default: () => localStorage.getItem('accessToken') || '',
    },
  },
  data() {
    return {
      dialog: this.visible,
      fields: [],
      drilldownData: [],
    };
  },
  watch: {
    visible(newVal) {
      this.dialog = newVal;
      if (newVal) {
        this.fetchDrilldownData();
      }
    },
    dialog(newVal) {
      this.$emit('update:visible', newVal);
    },
    filters: {
      deep: true,
      handler() {
        if (this.dialog) {
          this.fetchDrilldownData();
        }
      },
    },
    saleId() {
      if (this.dialog) {
        this.fetchDrilldownData();
      }
    },
  },
  methods: {
    async fetchDrilldownData() {
      let apiUrl = '';
      const requestParams = { ...this.filters };

      switch (this.drilldownLevel) {
        case 'L1':
          apiUrl = '/dashboard/crm/sales/drilldown/l1';
          break;
        case 'L2':
          apiUrl = '/dashboard/crm/sales/drilldown/l2';
          if (this.saleId) {
            requestParams.sale_id = this.saleId;
          }
          break;
        case 'L3':
          apiUrl = '/dashboard/crm/sales/drilldown/l3';
          if (this.saleId) {
            requestParams.sale_id = this.saleId;
          }
          break;
        case 'SITE_VISIT':
          // This could reuse PresalesDrilldownL3 or a new Sales-specific site visit endpoint
          apiUrl = '/dashboard/crm/presales/drilldown/l3'; // Reusing for now
          if (this.saleId) {
            // If drilling from a specific sale, filter site visits related to that sale's lead
            // This would require backend support to link sales to leads and then to site visits
            console.warn('Filtering site visits by saleId not yet implemented in backend.');
          }
          break;
        case 'SM':
          // This will need a new backend endpoint
          console.warn('SM-wise drilldown endpoint not yet implemented.');
          this.drilldownData = [];
          this.fields = [];
          return;
        default:
          console.warn('Invalid drilldown level:', this.drilldownLevel);
          return;
      }

      try {
        const response = await dashboardGet(this.baseApi, this.accessToken, apiUrl, requestParams);
        this.processDrilldownData(response.data.data);
      } catch (error) {
        console.error(`Error fetching sales drilldown ${this.drilldownLevel} data:`, error);
      }
    },
    processDrilldownData(data) {
      if (!data || data.length === 0) {
        this.fields = [];
        this.drilldownData = [];
        return;
      }
      this.fields = Object.keys(data[0]).map((key) => ({
        key,
        label: this.formatHeader(key),
      }));
      this.drilldownData = data;
    },
    formatHeader(key) {
      return key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    },
  },
};
</script>
